import { useDispatch } from 'react-redux';
import { showModal } from 'legacy/actions/modalActions';
import { useCreateOffer, useUpdateOffer } from 'legacy/events/hooks';
import { OfferType } from 'legacy/events/types';
import { OffersStep } from 'legacy/events/offers.types';
import {
  getChangedOffer,
  getUpdatedOfferWithIds
} from 'legacy/events/promoterOfferHelper';

interface UseOfferFormSubmissionProps {
  eventId: string;
  offerId?: string;
  isEditMode: boolean;
  initialValues: OfferType;
  setOffersStep: (step: OffersStep) => void;
}

export const useOfferFormSubmission = ({
  eventId,
  offerId,
  isEditMode,
  initialValues,
  setOffersStep
}: UseOfferFormSubmissionProps) => {
  const dispatch = useDispatch();
  const createOffer = useCreateOffer();
  const updateOffer = useUpdateOffer();

  const handleSubmit = (values: OfferType) => {
    const offerToSave = getUpdatedOfferWithIds(values);
    const existingOffer = getUpdatedOfferWithIds(initialValues);
    const updatedOffer = getChangedOffer(existingOffer, offerToSave);

    const onSuccess = () => {
      setOffersStep(OffersStep.OFFERS_LIST);
    };

    const onError = (error: any) => {
      dispatch(
        showModal('ALERT', {
          message: error?.message || 'Something went wrong'
        })
      );
    };

    if (isEditMode) {
      updateOffer.mutate(
        {
          offerId: offerId!,
          offer: updatedOffer
        },
        { onSuccess, onError }
      );
    } else {
      createOffer.mutate(
        {
          eventId,
          body: offerToSave
        },
        { onSuccess, onError }
      );
    }
  };

  return {
    handleSubmit,
    isSubmitting: createOffer.isLoading || updateOffer.isLoading
  };
};
